export default "__VITE_ASSET__DLF7zwn$__"